import { applyMiddleware, combineReducers, compose, createStore } from "redux";
import { connectRouter, routerMiddleware } from "connected-react-router";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import * as Sentry from "@sentry/browser";

import { History } from "history";
import { createBrowserHistory } from "history";
import createSentryMiddleware from "redux-sentry-middleware";
import promise from "redux-promise-middleware";
import thunk from "redux-thunk";

import getEnvironment from "utils/getEnvironment";

import reducers from "state/reducers";
import session from "state/reducers/session";

import { Environment } from "types";

const middleware = [thunk, promise];

if (getEnvironment() === Environment.PRODUCTION) {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN
  });

  middleware.push(createSentryMiddleware(Sentry));
}

const composeEnhancers =
  (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const persistConfig = {
  key: "root",
  storage,
  whitelist: ["session"]
};

const createRootReducer = (history: History) => {
  return combineReducers({
    ...reducers,
    session,
    router: connectRouter(history)
  } as any);
};

export const history = createBrowserHistory();
export const store = createStore(
  persistReducer(persistConfig, createRootReducer(history)),
  composeEnhancers(applyMiddleware(...middleware, routerMiddleware(history)))
);
export const persistor = persistStore(store);
